import { AppBar, Box, IconButton, Toolbar, Typography } from '@mui/material';
// import { AppBar, Badge, Box, IconButton, Toolbar, Typography } from '@mui/material';
import { useSidebarStore } from '@store/useSidebarStore';
import { utilityRegistry } from '@utilities/registry';
import { Menu } from 'lucide-react';
// import { Bell, CircleQuestionMark } from 'lucide-react';
import { useLocation } from 'react-router';

import { ThemeToggleButton } from './ThemeToggleButton';

const usePageTitle = (): string => {
  const location = useLocation();

  if (location.pathname === '/') {
    return 'Home';
  }

  const utility = utilityRegistry.find(candidate => location.pathname.startsWith(candidate.path));
  return utility?.title ?? 'Ops Utility Hub';
};

export const Topbar = () => {
  const title = usePageTitle();
  const openMobile = useSidebarStore(state => state.openMobile);

  return (
    <AppBar position="sticky">
      <Toolbar sx={{ gap: 1 }}>
        <IconButton
          aria-label="Open navigation"
          edge="start"
          onClick={openMobile}
          sx={{ display: { md: 'none', xs: 'inline-flex' } }}
        >
          <Menu size={20} />
        </IconButton>
        <Typography sx={theme => ({ color: theme.palette.text.heading, fontSize: 20, fontWeight: 600 })} variant="h6">
          {title}
        </Typography>
        <Box sx={{ flex: 1 }} />
        {/* TODO: May or may not use these, delete if they don't need implemented */}
        {/* <IconButton aria-label="Notifications">
          <Badge color="primary" overlap="circular" variant="dot">
            <Bell size={18} />
          </Badge>
        </IconButton>
        <IconButton aria-label="Help">
          <CircleQuestionMark size={18} />
        </IconButton> */}
        <ThemeToggleButton />
      </Toolbar>
    </AppBar>
  );
};
